import { useGlobal } from '@/utils/useGlobal';
import { useEffect } from 'react';
import styles from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';

export default function F() {
    const { useLang } = useGlobal();
    const { t } = useLang('PowerOcean.F');

    useEffect(() => {
        const AniContainer = window?.AniContainer;
        AniContainer.create({
            syncFromTo: [['.power-ocean-home-F .pc .img-box', { y: -360 }, { y: 0 }]],
            triggerElement: '.power-ocean-home-F',
            triggerHook: 1,
            offset: 0,
            duration: '100%',
            scrollUpdatePos: true,
        });
    }, []);

    return (
        <div className={`power-ocean-home-F ${styles['power-ocean-home-F']}`}>
            <div className="pc">
                <div className="text-box">
                    <div className="text-inner">
                        <div className="left">
                            <p className="sub-title">{t('label')}</p>
                            <h2 className="title">{t('title')}</h2>
                        </div>
                        <p className="right">{t('desc')}</p>
                    </div>
                </div>
                <div className="img-box">
                    <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1768903675890/6.jpg" alt={t('title')} />
                </div>
            </div>
            <div className="h5">
                <div className="text-box">
                    <div className="left">
                        <p className="sub-title">{t('label')}</p>
                        <h2 className="title">{t('title')}</h2>
                    </div>
                    <p className="right">{t('desc')}</p>
                </div>
                <div className="img-box">
                    <EcoImg
                        pc="https://websiteoss.ecoflow.com/upload/image/1768903728651/6.jpg"
                        alt={t`We take reliability seriously, for every single battery`}
                    />
                </div>
            </div>
        </div>
    );
}
